// import * as React from 'react';
import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { headerData } from "../../data/headerCostum";
import Logo from "../../assets/image/logo.png";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import SweetAlert2 from "react-sweetalert2";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      // color="#FFFFFF"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://makassarkota.go.id/">
        Pemerintah Kota Makassar
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

const LoginUser = () => {
  const navigate = useNavigate();
  const [skpd, setSkpd] = useState(null);
  const [opd, setOpd] = useState(null);
  const [swalProps, setSwalProps] = useState({});
  const [data, setData] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = (event) => {
    event.preventDefault();
    setOpenDialog(true);
    const data = new FormData(event.currentTarget);
    setData(data);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const sendData = () => {
    fetch(process.env.REACT_APP_API_URL + "api/pendaftar", {
      method: "post",
      headers: headerData,
      body: JSON.stringify({
        nama: data.get("nama").toString().toUpperCase(),
        no_hp: data.get("no_hp"),
        opd: data.get("opd"),
        jabatan: data.get("jabatan")
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.nama) {
          setSwalProps({
            show: true,
            title: "Sukses",
            icon: "success",
            text: "Data telah ditambahkan",
          });
          navigate("/konten", {
            state: {
              user: res,
            },
          });
        } else {
          setSwalProps({
            show: true,
            title: "Gagal",
            icon: "error",
            text: res.message,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setOpenDialog(false);
  };

  const getDataSKPD = useCallback(async () => {
    await fetch(process.env.REACT_APP_API_URL + "api/skpd", {
      method: "get",
      headers: headerData,
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        setSkpd(res.sort((a, b) => a.nama - b.nama));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [setSkpd]);

  useEffect(() => {
    if (!skpd) {
      getDataSKPD();
    }
    // redirect to absensi
    // navigate('/absensi');
  }, [skpd, getDataSKPD]);

  return (
    <Box
      width={"100vw"}
      height={"100vh"}
      sx={{
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "right bottom",
        position: "absolute",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <ThemeProvider theme={defaultTheme}>
        <Container sx={{ paddingX: 0 }} component="main" maxWidth="xs">
          <CssBaseline />
          <SweetAlert2
            {...swalProps}
            didClose={() => {
              setSwalProps({});
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "start",
              height: "100vh",
            }}
          >
            <Box marginTop={10}>
              <img src={Logo} alt="Main Flyer" width={"100%"} />
            </Box>
            <Box sx={{ marginTop: 2 }}>
              <Typography fontSize={17} align="center" fontWeight={700}>
                {"CEK LONGWIS"}
              </Typography>
            </Box>
            <Box
              component="form"
              onSubmit={handleOpenDialog}
              sx={{ mt: 1, paddingX: 2 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                placeholder="Username"
                name="username"
                autoComplete="username"
                autoFocus
                size="small"
                sx={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: 2,
                }}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                placeholder="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                size="small"
                sx={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: 2,
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  background: `linear-gradient(90deg, rgba(29, 195, 159, 1), rgba(143, 249, 171, 1));`,
                  textTransform: "none",
                  fontWeight: 500,
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "rgba(65, 178, 87, 0.7)",
                  },
                }}
                size="medium"
              >
                {'Masuk'}
              </Button>
            </Box>
            <Box>
              <Copyright />
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </Box>
  );
};

export default LoginUser;
